function interpolateStringToTemplate(template, params) {
  const keys = Object.keys(params);
  const values = Object.values(params);
  return new Function(...keys, `return \`${template}\`;`)(...values);
}

export default interpolateStringToTemplate;
